// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/blog_post/v1/blog_post.proto (package fingertip.creator.blog_post.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, StringValue } from "@bufbuild/protobuf";
import { BlogPost } from "../../../common/type/v1/blog_post_pb.js";
import { PageInfo } from "../../../common/type/v1/page_info_pb.js";
import { Media, MediaValue } from "../../../common/type/v1/media_pb.js";
import { BlogPostStatus } from "../../../common/enum/v1/blog_post_status_pb.js";

/**
 * @generated from message fingertip.creator.blog_post.v1.GetBlogPostPublicRequest
 */
export const GetBlogPostPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.GetBlogPostPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "post_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.GetBlogPostPublicResponse
 */
export const GetBlogPostPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.GetBlogPostPublicResponse",
  () => [
    { no: 1, name: "post", kind: "message", T: BlogPost },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.GetBlogPostsPublicRequest
 */
export const GetBlogPostsPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.GetBlogPostsPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.GetBlogPostsPublicResponse
 */
export const GetBlogPostsPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.GetBlogPostsPublicResponse",
  () => [
    { no: 1, name: "posts", kind: "message", T: BlogPost, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.GetBlogPostRequest
 */
export const GetBlogPostRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.GetBlogPostRequest",
  () => [
    { no: 1, name: "post_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "post_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.GetBlogPostResponse
 */
export const GetBlogPostResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.GetBlogPostResponse",
  () => [
    { no: 1, name: "post", kind: "message", T: BlogPost },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.GetBlogPostsRequest
 */
export const GetBlogPostsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.GetBlogPostsRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.GetBlogPostsResponse
 */
export const GetBlogPostsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.GetBlogPostsResponse",
  () => [
    { no: 1, name: "posts", kind: "message", T: BlogPost, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.CreateBlogPostRequest
 */
export const CreateBlogPostRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.CreateBlogPostRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "feature_image", kind: "message", T: Media },
    { no: 5, name: "feature_image_caption", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "is_featured", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "meta_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "meta_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "og_image", kind: "message", T: Media },
    { no: 11, name: "status", kind: "enum", T: proto3.getEnumType(BlogPostStatus) },
    { no: 12, name: "post_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.CreateBlogPostResponse
 */
export const CreateBlogPostResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.CreateBlogPostResponse",
  () => [
    { no: 1, name: "post_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "post_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.UpdateBlogPostRequest
 */
export const UpdateBlogPostRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.UpdateBlogPostRequest",
  () => [
    { no: 1, name: "post_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "html", kind: "message", T: StringValue },
    { no: 6, name: "content", kind: "message", T: StringValue },
    { no: 7, name: "feature_image", kind: "message", T: MediaValue },
    { no: 8, name: "feature_image_caption", kind: "message", T: StringValue },
    { no: 9, name: "is_featured", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "meta_title", kind: "message", T: StringValue },
    { no: 11, name: "meta_description", kind: "message", T: StringValue },
    { no: 12, name: "og_image", kind: "message", T: MediaValue },
    { no: 13, name: "status", kind: "enum", T: proto3.getEnumType(BlogPostStatus) },
    { no: 14, name: "new_post_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.UpdateBlogPostResponse
 */
export const UpdateBlogPostResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.UpdateBlogPostResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.DeleteBlogPostRequest
 */
export const DeleteBlogPostRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.DeleteBlogPostRequest",
  () => [
    { no: 1, name: "post_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.DeleteBlogPostResponse
 */
export const DeleteBlogPostResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.DeleteBlogPostResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.GetBlogPostSlugRequest
 */
export const GetBlogPostSlugRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.GetBlogPostSlugRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "post_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.GetBlogPostSlugResponse
 */
export const GetBlogPostSlugResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.GetBlogPostSlugResponse",
  () => [
    { no: 1, name: "already_taken", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.DuplicateBlogPostRequest
 */
export const DuplicateBlogPostRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.DuplicateBlogPostRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "post_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.blog_post.v1.DuplicateBlogPostResponse
 */
export const DuplicateBlogPostResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.blog_post.v1.DuplicateBlogPostResponse",
  () => [
    { no: 1, name: "post_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "post_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

